import { ArrowUpDown, ArrowUp, ArrowDown, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';

export interface SortOption {
  value: string;
  label: string;
  direction: 'asc' | 'desc';
}

export interface SortControlProps {
  /** Available sort options */
  sortOptions: SortOption[];
  /** Currently active sort */
  activeSort: { orderBy: string; orderDirection: 'asc' | 'desc' };
  /** Callback when the user picks a sort option */
  onSortChange: (orderBy: string, orderDirection: 'asc' | 'desc') => void;
}

export function SortControl({ sortOptions, activeSort, onSortChange }: SortControlProps) {
  const activeOption = sortOptions.find(
    (o) => o.value === activeSort.orderBy && o.direction === activeSort.orderDirection,
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <ArrowUpDown className="h-3.5 w-3.5" />
          <span className="ml-1">{activeOption?.label ?? 'Sort'}</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {sortOptions.map((option) => {
          const isActive =
            option.value === activeSort.orderBy &&
            option.direction === activeSort.orderDirection;

          return (
            <DropdownMenuItem
              key={`${option.value}-${option.direction}`}
              onClick={() => { onSortChange(option.value, option.direction); }}
            >
              <span className="mr-2 flex h-4 w-4 items-center justify-center">
                {isActive && <Check className="h-3.5 w-3.5" />}
              </span>
              <span className="flex-1">{option.label}</span>
              <span className="ml-2 flex h-4 w-4 items-center justify-center text-muted-foreground">
                {option.direction === 'asc' ? (
                  <ArrowUp className="h-3 w-3" />
                ) : (
                  <ArrowDown className="h-3 w-3" />
                )}
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
